import { createAction } from 'redux-actions';
import { StudioState } from '../../types/store';

export interface RefreshTableSuccessPayload
  extends Pick<
    StudioState,
    | 'freeCapacity'
    | 'maxCapacity'
    | 'resultsTotalCount'
    | 'tags'
    | 'selectedFolder'
    | 'originalsData'
  > {
  /** Prevent deselecting any selected deviations after refresh? */
  preserveSelection?: boolean;

  /** App data (client id/secret pairs) - only relevant in apps section */
  appData?: NonNullable<StudioState['apps']>['appData'];
}

export const updateSelection = createAction(
  'STUDIO.UPDATE_SELECTION',
  (selection: StudioState['selection']) => ({ selection })
);

export const reorderRow = createAction(
  'STUDIO.REORDER_ROW',
  (folderId: number, deviationId: number, position: number) => ({
    folderId,
    deviationId,
    position,
  })
);

export const reorderMulti = createAction(
  'STUDIO.REORDER_MULTI',
  (
    folderId: number,
    deviationIds: { deviationId: number; position: number }[]
  ) => ({ folderId, deviationIds })
);

export const refreshTable = createAction(
  'STUDIO.REFRESH_TABLE',
  ({
    /**
     * If true, we'll try to drop the user back on their current page of results
     */
    preservePage,
    preserveSelection,
  }: {
    preservePage: boolean;
    preserveSelection?: boolean;
  }) => ({
    preservePage,
    preserveSelection,
  })
);

export const refreshTableSuccess = createAction(
  'STUDIO.REFRESH_TABLE_SUCCESS',
  (payload: RefreshTableSuccessPayload) => payload
);

export const refreshTableError = createAction(
  'STUDIO.REFRESH_TABLE_ERROR',
  (error: any) => ({ error })
);

export const fetchTableNext = createAction(
  'STUDIO.FETCH_TABLE_NEXT',
  (streamId: string, onSuccess: () => void) => ({ streamId, onSuccess })
);

export const fetchTablePrevious = createAction(
  'STUDIO.FETCH_TABLE_PREVIOUS',
  (streamId: string, onSuccess: () => void) => ({ streamId, onSuccess })
);

export const fetchTableFirstPage = createAction(
  'STUDIO.FETCH_TABLE_FIRST_PAGE',
  (streamId: string, onSuccess: () => void) => ({ streamId, onSuccess })
);

export const fetchTableLastPage = createAction(
  'STUDIO.FETCH_TABLE_LAST_PAGE',
  (streamId: string, onSuccess: () => void) => ({ streamId, onSuccess })
);

export const setTableLayout = createAction(
  'STUDIO.SET_TABLE_LAYOUT',
  (layout: 'list' | 'grid') => ({ layout })
);
